import React, {useEffect, useState} from "react";
import {useGlobal} from "../../Store";
import {Link} from "react-router-dom";
import {postData} from "../../Utils/Server";
import Endpoints from "../../Constants/Endpoints";
import {useHistory} from "react-router-dom";
import {ERROR, Notify, SUCCESS} from "../../Utils/Notify";
import {updateDocumentTitle} from "../../Utils/Common";
import {ReasonCaptureModal} from "../Common/ReasonCaptureModal";
import styled from "styled-components";
import PageLayout from "../Layout/PageLayout";
import {Button, Card, Tabs, DataTable, Spinner} from "../UI";
import {tokens} from "../../theme/tokens";

const InfoTable = styled.table`
    width: 100%;
    border-collapse: collapse;
    td {
        padding: ${tokens.spacing[3]} ${tokens.spacing[4]};
        border-bottom: 1px solid ${tokens.colors.divider};
        font-size: ${tokens.typography.size.base};
        vertical-align: top;
    }
    td:first-child {
        color: ${tokens.colors.muted};
        width: 40%;
    }
    td:last-child {
        color: ${tokens.colors.heading};
    }
    tr:last-child td {
        border-bottom: 0;
    }
`;

const ReviewTable = styled.table`
    width: 100%;
    border-collapse: collapse;
    th, td {
        padding: ${tokens.spacing[3]} ${tokens.spacing[4]};
        border-bottom: 1px solid ${tokens.colors.divider};
        font-size: ${tokens.typography.size.base};
        text-align: left;
        vertical-align: top;
    }
    th {
        color: ${tokens.colors.muted};
        font-size: ${tokens.typography.size.xs};
        font-weight: ${tokens.typography.weight.bold};
        letter-spacing: 0.06em;
        text-transform: uppercase;
        background: ${tokens.colors.cream};
    }
    tbody tr:last-child td {
        border-bottom: 0;
    }
`;

const ClientDetails = props => {
    let history = useHistory();
    const [globalState, globalActions] = useGlobal();
    const [isLoading, setIsLoading] = useState(false);
    const [item, setItem] = useState({title: ''});
    const [pendingAction, setPendingAction] = useState(null);
    const [name, setName] = useState('');
    const [phone, setPhone] = useState('');
    const [email, setEmail] = useState('');
    const [tab, setTab] = useState("details");

    const [requestsListOngoing, setRequestListOngoing] = useState([]);
    const [requestsListAll, setRequestListAll] = useState([]);
    const [businessList, setBusinessList] = useState([]);

    const [ratesList, setRatesList] = useState([]);
    const [requestType, setRequestType] = useState('');
    const [meansType, setMeansType] = useState('');
    const [peakRate, setPeakRate] = useState('');
    const [normalRate, setNormalRate] = useState('');

    const columns = [
        {
            name: '#',
            sortable: true,
            cell: row => <div><Link to={"/request/" + row.id}>{row.request_code}</Link></div>,
        },
        {
            name: 'Type',
            selector: 'pick_up_type',
            sortable: true,
        },
        {
            name: 'Pick up',
            selector: 'pick_up_location',
            sortable: true,
        },
        {
            name: 'Delivery type',
            selector: 'delivery_type',
            sortable: true,
        },
        {
            name: 'Means',
            selector: 'means',
            sortable: true,
        },
        {
            name: 'Status',
            selector: 'status',
            sortable: true,
        },
        {
            name: 'Fee',
            selector: 'fee',
            sortable: true,
        }
    ]

    const businessColumns = [
        {
            name: 'Name',
            sortable: true,
            cell: row => <div><Link to={"/business/" + row.id}>{row.name}</Link></div>,
        },
        {
            name: 'Contact email',
            selector: 'contact_email',
        },
        {
            name: 'Contact phone',
            selector: 'contact_phone',
        },
        {
            name: 'Client Status',
            cell: row => row.active === 1 ? <span>Active</span> : <span>Inactive</span>,
        },
        {
            name: 'Admin Status',
            cell: row => row.admin_active === 1 ? <span>Active</span> : <span>Inactive</span>,
        }
    ]

    const {id} = props.match.params;

    const load = () => {
        let data = new FormData();
        data.append("id", id);

        setIsLoading(true);
        postData(Endpoints.CLIENT_DETAIL, data)
            .then(res => res.json())
            .then(res => {
                setIsLoading(false);
                if (res.success === 1) {
                    setItem(res.data);
                    setName(res.data.name);
                    setPhone(res.data.phone);
                    setEmail(res.data.email);
                    updateDocumentTitle(res.data.name)
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.log(error)
            });
    };

    useEffect(() => {
        load()
        loadRequests(false, "ongoing")
        loadRequests(false, "completed")
        loadBusinesses(false)
    }, []);

    function updateStatus(number, reason) {
        let data = new FormData();
        data.append("id", id);
        data.append("status", number);
        data.append("reason", reason);

        setIsLoading(true);
        postData(Endpoints.CLIENT_UPDATE_STATUS, data)
            .then(res => res.json())
            .then(res => {
                setIsLoading(false);
                Notify(SUCCESS ? res.data : res.message, res.success === 1 ? SUCCESS : ERROR);

                if (res.success === 1) {
                    load()
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.log(error)
            });
    }

    const loadRequests = (loadMore, status) => {
        let data = new FormData();
        data.append("client_id", id);
        data.append("status", status);
        data.append("offset", status === "ongoing" ? requestsListOngoing.length : requestsListAll.length);

        setIsLoading(true);

        postData(Endpoints.REQUEST_LIST_USER, data)
            .then(res => res.json())
            .then(res => {
                setIsLoading(false);
                if (status === "ongoing") {
                    let currentPosts = loadMore ? requestsListOngoing : [];
                    currentPosts = currentPosts.concat(...res.data);
                    setRequestListOngoing(currentPosts);
                } else {
                    let currentPosts = loadMore ? requestsListAll : [];
                    currentPosts = currentPosts.concat(...res.data);
                    setRequestListAll(currentPosts);
                }

            })
            .catch((error) => {
                setIsLoading(false);
                console.log(error)
            });
    };

    const loadBusinesses = (loadMore) => {
        let data = new FormData();
        data.append("client_id", id);
        data.append("offset", businessList.length);

        setIsLoading(true);

        postData(Endpoints.BUSINESS_LIST, data)
            .then(res => res.json())
            .then(res => {
                setIsLoading(false);
                let currentPosts = loadMore ? businessList : [];
                currentPosts = currentPosts.concat(...res.data);
                setBusinessList(currentPosts);
            })
            .catch((error) => {
                setIsLoading(false);
                console.log(error)
            });
    };


    function loadRates() {
        let data = new FormData();
        data.append("user_id", id);
        setIsLoading(true)
        postData(Endpoints.RATE_LIST, data)
            .then(res => res.json())
            .then(res => {
                setIsLoading(false);
                if (res.success === 1) {
                    setRatesList(res.data || []);
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.log(error)
            });
    }

    return (
        <PageLayout
            title={item.name}
            actions={item.title !== '' ? (
                <>
                    {isLoading && <Spinner size={20}/>}
                    {!isLoading &&
                    <Button
                        variant={item.status === 1 ? "danger" : "primary"}
                        onClick={e => setPendingAction(item.status === 1 ? 0 : 1)}
                    >
                        {item.status === 1 ? "Deactivate" : "Activate"}
                    </Button>
                    }
                    <Link to="/clients">
                        <Button variant="outline">Back to clients</Button>
                    </Link>
                </>
            ) : null}
        >
            {item.title !== '' &&
            <>
                <Tabs
                    tabs={[
                        {key: "details", label: "Details"},
                        {key: "ongoing", label: "Ongoing requests"},
                        {key: "completed", label: "Completed requests"},
                        {key: "reviews", label: "Client reviews"},
                        {key: "businesses", label: "Businesses"},
                    ]}
                    value={tab}
                    onChange={setTab}
                />

                {tab === "details" &&
                <Card>
                    <InfoTable>
                        <tbody>
                        <tr>
                            <td>Name</td>
                            <td><b>{item.name}</b></td>
                        </tr>
                        <tr>
                            <td>Email</td>
                            <td><b>{item.email}</b></td>
                        </tr>
                        <tr>
                            <td>Phone</td>
                            <td><b>{item.phone}</b></td>
                        </tr>
                        <tr>
                            <td>Status</td>
                            <td><b>{item.status === 0 ? "INACTIVE" : "ACTIVE"}</b></td>
                        </tr>
                        <tr>
                            <td>Registered on</td>
                            <td><b>{item.date_added}</b></td>
                        </tr>
                        </tbody>
                    </InfoTable>
                </Card>
                }

                {tab === "ongoing" &&
                <Card padded={false}>
                    <DataTable
                        columns={columns}
                        data={requestsListOngoing}
                        pointerOnHover={true}
                        noHeader={true}
                        onRowClicked={e => {
                            history.push('/request/' + e.id);
                        }}
                    />
                </Card>
                }

                {tab === "completed" &&
                <Card padded={false}>
                    <DataTable
                        columns={columns}
                        data={requestsListAll}
                        pointerOnHover={true}
                        noHeader={true}
                        onRowClicked={e => {
                            history.push('/request/' + e.id);
                        }}
                    />
                </Card>
                }

                {tab === "businesses" &&
                <Card padded={false}>
                    <DataTable
                        columns={businessColumns}
                        data={businessList}
                        pointerOnHover={true}
                        noHeader={true}
                        onRowClicked={e => {
                            history.push('/business/' + e.id);
                        }}
                    />
                </Card>
                }

                {tab === "reviews" &&
                <Card padded={false}>
                    <ReviewTable>
                        <thead>
                        <tr>
                            <th>Request</th>
                            <th>Pick up location</th>
                            <th>Client review</th>
                        </tr>
                        </thead>
                        <tbody>
                        {requestsListAll.map((i, k) => <tr>
                                <td><Link to={"/request/" + i.id}>#{i.request_code}</Link></td>
                                <td>{i.pick_up_location}</td>
                                <td>
                                    <div>
                                        <b>Ratings</b> : {i.customer_rating} / 5<br/>
                                        <b>Review</b> : {i.customer_feedback}<br/>
                                    </div>
                                </td>
                            </tr>
                        )}
                        </tbody>
                    </ReviewTable>
                </Card>
                }
            </>
            }
            {pendingAction !== null &&
            <ReasonCaptureModal
                title={pendingAction === 0 ? "Deactivate client" : "Activate client"}
                onCancel={() => setPendingAction(null)}
                onConfirm={reason => { updateStatus(pendingAction, reason); setPendingAction(null); }}
            />
            }
        </PageLayout>
    )
};


export default ClientDetails
